<template>
  <div class="faq-container" v-if="faqs.length > 0">
    <div v-if="showTitle" class="title">
      {{ intl[$store.state.lang]["related-questions"] }}
    </div>
    <baseLoader v-if="faqLoader"></baseLoader>
    
    <div v-else class="accordion" id="faqContainer">
      <div class="accordion-item" v-for="(faq, index) in faqs" :key="faq.id">
        <h2 class="accordion-header" :id="faq.id">
          <h4
            class="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            :data-bs-target="'#collapse-' + index"
            aria-expanded="false"
            aria-controls="collapseOne"
          >
            <span>{{ faq.id + ") " + faq.title }}</span>
          </h4>
        </h2>
        <div
          :id="'collapse-' + index"
          :class="index === 0 ? 'accordion-collapse collapse show' : 'accordion-collapse collapse'"
          aria-labelledby="headingOne"
          data-bs-parent="#faqContainer"
        >
          <div v-html="faq.introtext" :class="index === 0 ? 'accordion-body show' : 'accordion-body'"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import intl from "./intl/intl";
import axios from "axios";
import BaseLoader from "../loaders/baseLoader/BaseLoader.vue"
import { apiUrls } from "../../api/apiUrls";
export default {
  name: "faq",
  components: {
    "baseLoader": BaseLoader,
  },
  props: {
    setPaginaLoaderCallback: {
        type: Function,
        default: (value) => {console.log("Faq LOADER: ",value)},
      },
    answerId: {
      type: Number,
      default: null,
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    
    renderComponent: {
      type: Boolean,
      default: true,
    },
    onLoadDataEnded: {
      type: Function,
      default: (response,faqs) => {
        console.log("Caricamento dati finito");
      },
    },
    onLoadDataStarted: {
      type: Function,
      default: () => {
        console.log("Caricamento dati iniziato");
      },
    },
  },

  created() {
    if (this.answerId) {
      this.getAnswerDetail();
    }
  },

  data: function () {
    return {
      intl: intl,
      test: true,
      faqLoader: false,
      faqs: [],
    };
  },
  methods: {


    getAnswerDetail() {
      if (this.answerId) {
        this.faqLoader = true;
        this.onLoadDataStarted()
        axios
          .get(apiUrls["answer_detail"] + this.answerId)
          .then((response) => {
            if (
              response.data &&
              response.data.answer_faq &&
              response.data.answer_faq.length > 0
            ) {
              response.data.answer_faq.map((answerFaq) => {
                if (answerFaq.faq) {
                  this.faqs.push(answerFaq.faq);
                }
              });
            }
            this.onLoadDataEnded(response,this.faqs)
        
            this.faqLoader = false;
          })
          .catch((error) => {
            this.onLoadDataEnded(error,this.faqs)
       
            this.faqLoader = false;
          });
      }
    },
  },
  watch: {
    faqLoader : {
                handler : function(newValue, oldValue) {
                    if(oldValue !== newValue){
                        this.setPaginaLoaderCallback({faqLoader: newValue})
                    }                
                },
                deep : true
        },
    answerId: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getAnswerDetail();
      }
    },
  },
  computed: {},
};
</script>
